export default "__VITE_ASSET__BhWKExtF__"